import '../src/assets/css/bootstrap.min.css';
import '../src/assets/css/app-styles.css';
import '../src/assets/demo/demo.css';
import '../src/assets/css/agrix-styles.css';
import '../src/assets/css/font-awesome.css';
import '../src/assets/css/font-awesome5.css';
import '../src/assets/css/left-navi.css'; 
import $ from "jquery"; 
import './config';
import './index.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker'; 
import { ClipLoader, RingLoader, GridLoader, ScaleLoader } from 'react-spinners';
import jsonToken from 'jsonwebtoken';
import Idle from "react-idle";
import { deleteOldTickets, onStorageEvent, storeTicket } from './config/Idle';
import { CommonGet, CommonPostIDServer } from './utils/CommonFetch';
import { UserPasswordChange } from './components/Modules/User/Pages/passwordChange';
 
import config from "react-global-configuration";

var serviceUrl = config.get('apidomain');
var idetityServiceUrl = config.get('identityDomain');
var reactWebUrl = config.get('reactDomain');
var identityClientID = config.get('identityClientID');
var projectID = config.get('projectID');

var functionsWindow;
var mgr;
let concurrentDenied = false;

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
window.addEventListener('storage', onStorageEvent, false);
 
    ReactDOM.render(
        <BrowserRouter basename={baseUrl}>
            {/* <App isFirstLogin={user.profile.isFirstLogin == 'true'} /> */}
            <App/>
        </BrowserRouter>,
        rootElement);
     
 
registerServiceWorker();


